import React, { useState, useEffect } from 'react';
import axios from '../../lib/axios';
import { constants } from '../../helpers/constants';
import Meta from '../../components/Meta';
import { MintingCarousel } from '../../components/carousel/mintingCarousel';
import { HeadLine } from '../../components/component';
import { MintingCard, TokenMintingCard } from '../../components/minting/mintingCard';

const Minting = ({ liveMintings }) => {
  const [page, setPage] = useState(1);
  const [endedMintings, setEndedMintings] = useState([]);
  const [upcomingMintings, setUpcomingMintings] = useState([]);
  const [carouselMintings, setCarouselMintings] = useState([]);

  const fetchMintings = async ({ status }) => {
    let config;
    config = {
      url: `${constants.api.url_new}/launchpad`,
      method: constants.httpMethods.get,
      params: { limit: 50, page, status },
    };
    const { data } = await axios(config);
    // setEndedMintings([...endedMintings, ...data.results]);
    status === 'ended' ? setEndedMintings(data.results) : setUpcomingMintings(data.results);
  };

  const categories = [
    {
      name: 'Live',
      launchpads: liveMintings,
    },
    {
      name: 'Upcoming',
      launchpads: upcomingMintings,
    },
    {
      name: 'Ended',
      launchpads: endedMintings,
    },
  ];

  useEffect(() => {
    fetchMintings({ status: 'ended' });
    fetchMintings({ status: 'upcoming' });
  }, [page]);

  useEffect(() => {
    setCarouselMintings([...liveMintings, ...upcomingMintings, ...endedMintings]);
  }, [liveMintings, endedMintings, upcomingMintings]);

  return (
    <>
      <Meta title={`Launchpad || Bit5 | Create. Collect. Connect.`} />
      {carouselMintings?.length > 0 && <MintingCarousel mintings={carouselMintings} />}
      {categories.map((c, i) => {
        const { name, launchpads } = c;

        return (
          <>
            {launchpads.length > 0 && (
              <div
                key={`category-${name}-${i}`}
                className='container select-none py-6 lg:!max-w-[1400px]'
              >
                <HeadLine
                  text={name}
                  classes={'mb-4 text-3xl font-bold text-jacarta-700 dark:text-white'}
                />
                <div className='grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-3'>
                  {launchpads.map((launchpad, i) => {
                    if (launchpad?.mintType === 'nft') {
                      return (
                        <MintingCard
                          key={`${i}-${launchpad?.collectionAddress}-${launchpad?.id}`}
                          minting={launchpad}
                        />
                      );
                    }
                    return (
                      <TokenMintingCard
                        key={`${i}-${launchpad?.tokenAddress}-${launchpad?.id}`}
                        minting={launchpad}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </>
        );
      })}
    </>
  );
};

export async function getServerSideProps() {
  try {
    let config;
    config = {
      url: `${constants.api.url_new}/launchpad`,
      method: constants.httpMethods.get,
      params: { limit: 50, status: 'live' },
    };
    const { data } = await axios(config);
    return {
      props: {
        liveMintings: data?.results,
      },
    };
  } catch (error) {
    return {
      props: {
        liveMintings: [],
      },
    };
  }
}

export default Minting;
